import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { capitalize } from "@material-ui/core";
import { Menu, MenuLabel, FieldWrapper } from "./BrandingSortMenu.style";
import { useGameBrandingDataQuery } from "../settings/Settings.state";
import SortableList from "../common/SortableList";

const SortMenu = ({ menu, control, onChange }) => {
    return (
        <Menu>
            <MenuLabel>{menu?.title}</MenuLabel> {control({
                defaultValue: menu?.order,
                setValue: position => onChange({
                    [menu?.key]: position,
                }) 
            })}
        </Menu>
    )
}

const BrandingSortMenu = ({ useQuery }) => {
    const { t } = useTranslation();
    const { data: branding } = useGameBrandingDataQuery();
    const [, setConfig] = useQuery()

    const displayMenu = useMemo(() => {
        const menuTranslations = {
            'challenges_order': t('Challenges'),
            'stream_order': t('Stream'),
            'leaderboard_order': t('Leaderboard'),
            'npcs_order': t('Characters'),
            'reels_order': t('Reels'),
            'rewards_order': t('Rewards'),
            'join_order': t('Join'),
            'notifications_order': t('Notifications'),
            'help_order': t('Help'),
            'custom_order': t('Custom'),
        }
        return Object.entries(branding?.main_menu || {}).map(([key, obj]) => {
            const keyOrder = `${key}_order`
            return {
                key,
                keyOrder,
                order: obj?.order,
                title: obj?.title || menuTranslations[`${key}_order`] || capitalize(key),
            }
        })
    }, [branding?.main_menu, t])

    const onMove = ({ payload }) => {
        setConfig(payload)
    }

    return (
        <FieldWrapper>
            <label className="form-label">{t('Menu order')}</label>
            <SortableList>
                {
                    displayMenu.map((o, key) => (
                        <SortMenu onChange={(v) => {
                            onMove({ payload: { [o?.keyOrder]: Number(v[o?.key]) } })
                        }} menu={o} key={key} />
                    ))
                }
            </SortableList>
        </FieldWrapper>
    )
}

export default BrandingSortMenu